// API configuration and helper functions
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

// Utility to check if we're in browser environment
export const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

// Safe DOM operations
export const safeDocumentOperation = (operation) => {
  if (isBrowser) {
    return operation();
  }
  return null;
};

export const safeWindowOperation = (operation) => {
  if (isBrowser) {
    return operation();
  }
  return null;
};

// Convert name to URL-friendly slug (spaces to hyphens, lowercase)
export const toUrlSlug = (name) => {
  if (!name) return '';
  return name
    .toLowerCase()
    .replace(/\s+/g, '-')      // Replace spaces with hyphens
    .replace(/[()]/g, '')       // Remove parentheses
    .replace(/'/g, '-')         // Replace apostrophes with hyphens
    .replace(/--+/g, '-')       // Replace multiple hyphens with single
    .replace(/^-|-$/g, '');     // Remove leading/trailing hyphens
};

// Convert URL slug back to display name (hyphens to spaces, title case)
export const fromUrlSlug = (slug) => {
  if (!slug) return '';
  
  // Special cases for known multi-word names
  const specialCases = {
    'usa': 'USA',
    'south-africa': 'South Africa',
    'new-zealand': 'New Zealand',
    'napa-valley': 'Napa Valley',
    'red-wine': 'Red wine',
    'white-wine': 'White wine',
    'rose-wine': 'Rose wine',
    'sparkling-wine': 'Sparkling wine',
    'white-sparkling': 'White sparkling',
    'rose-sparkling': 'Rose sparkling'
  };
  
  if (specialCases[slug]) {
    return specialCases[slug];
  }
  
  // Default: convert hyphens to spaces and title case
  return slug
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
